export default __webpack_public_path__ + "static/media/profile-header.d0949a35.jpg";